import { writable } from "svelte/store";

export const selected_account = writable("");
